import React from 'react';
import { connect } from "react-redux";
import {Grid} from "semantic-ui-react";
import VeritasHeader from "../../../shared/VeritasHeader";
import KYCServicesTable from "./KYCServicesTable";
import {fetchKYCServices} from "../../actions/ServicesActions";
import {InlineLoading} from "../../../../common/partials/Loading";
import KYCListSidebarFilters from "./KYCListSidebarFilters";
import Breadcrumb from '../../../../common/partials/Breadcrumb';
import { setBreadCrumb } from '../../../breadcrumb/BreadcrumbActions';
import Sidebar from "../../../../common/components/Sidebar";
import VeritasSidebarButtons from "../../../shared/VeritasSidebarButtons";

export class KYCServicesListPage extends React.Component {

    componentDidMount() {
        document.title = `Veritas - KYC Services`;
        // If the application reloads at this point, make an API call
        // to get all the services so that for a possible navigation
        // directly to the KYC or KYB Services List page, the data is
        // loaded for rendering. This will also help in refreshing the list
        // if any edits are performed on the detail page.
        this.props.getKYCServices();
        this.props.setBreadCrumb({
            parent:  { url: '/veritas', text: 'Veritas' },
            list:    { url: '/veritas/kyc-services', text: 'KYC Services' },
            service: { url: '', text: ''},
            source:  { url: '', text: ''},
        })
    }

    render() {
        return (
            <div className="veritas">
                <VeritasHeader />
                <Grid relaxed={true}>
                    <Grid.Column width={3}>
                        <Sidebar>
                            <VeritasSidebarButtons />
                            <div className="divider-background">
                                <hr />
                            </div>
                            <KYCListSidebarFilters />
                        </Sidebar>
                    </Grid.Column>
                    <Grid.Column width={13}>
                        <Breadcrumb />
                        {this.props.kyc_filtered_state
                            ? (<KYCServicesTable KYCServices={this.props.filtered_kyc_services} />)
                            : (<InlineLoading />) }
                    </Grid.Column>
                </Grid>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    kyc_services: state.veritas.services.kyc_services,
    filtered_kyc_services: state.veritas.services.filtered_kyc_services,
    kyc_filtered_state: state.veritas.services.kyc_filtered_state,
});

const mapDispatchToProps = dispatch => ({
    getKYCServices: () => { dispatch(fetchKYCServices()) },
    setBreadCrumb: (crumb) => {dispatch(setBreadCrumb(crumb))},
});


export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(KYCServicesListPage)
